import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function FAQSection() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Es esto legal?',
    answer: '100%. Cada estrategia está basada en regulaciones publicadas por el IRS. No son lagunas ni trucos — son derechos que ya tienes y no has ejercido.'
  }, {
    question: '¿Y si me auditan?',
    answer: 'Hacer una enmienda correctamente en realidad reduce el riesgo de auditoría. El eBook explica cómo hacerlo de forma documentada y correcta.'
  }, {
    question: '¿Necesito un contador para aplicar esto?',
    answer: 'No. El eBook está escrito para que puedas entenderlo y aplicarlo tú mismo, o llevarlo a tu preparador para que lo implemente.'
  }, {
    question: '¿Qué pasa si ya pasaron los 3 años?',
    answer: 'Para años que ya vencieron, no hay recuperación — pero hay estrategias para maximizar el año actual y los próximos. Eso también está cubierto.'
  }, {
    question: '¿Es esto para mi situación específica?',
    answer: 'Si eres contribuyente en USA, tienes hijos, o alguna vez te tocó pagar al IRS — al menos uno de los 3 hacks aplica a ti.'
  }, {
    question: '¿Por qué es tan barato?',
    answer: 'Porque el objetivo es que llegue a la mayor cantidad de familias latinas posible. El precio no refleja el valor — refleja la misión.'
  }];
  return <section className="bg-navy-dark py-16 md:py-24" data-id="element-26">
      <div ref={elementRef} className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-27">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white text-center mb-12" data-id="element-28">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-29">
          {faqs.map((faq, index) => <div key={index} className="bg-navy-light border border-white/10 rounded-xl overflow-hidden transition-all duration-300" data-id="element-30">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-31">
                <span className="text-lg md:text-xl font-bold text-white pr-4" data-id="element-32">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-gold-primary flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-33" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-34">
                <p className="text-lg text-gray-300" data-id="element-35">{faq.answer}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}